import React, { StrictMode } from "react"
import { MantineProvider } from "@mantine/core"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router"
import App from "./App"

import "./styles/index.css"
import "@/config/error.config"
import { mantineTheme } from "@/config/theme.config"
import { Notifications } from "@mantine/notifications"
import { ModalsProvider } from "@mantine/modals"
import { Toaster } from "./components/ui/sonner"
import { TooltipProvider } from "./components/ui/tooltip"
import { QueryClientProvider } from "@tanstack/react-query"
import { queryClient } from "./lib/query-client"

const root = document.getElementById("root")!

ReactDOM.createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <MantineProvider theme={mantineTheme}>
          <ModalsProvider>
            <TooltipProvider>
              <App />
            </TooltipProvider>
            <Notifications />
            <Toaster richColors position="top-center" />
          </ModalsProvider>
        </MantineProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
)
